module.exports = __webpack_public_path__ + "img/myFinished.20fcc553.svg";